import { OnboardingContainer } from 'components/onboarding/onboarding.container';

export const PrivateRoutesContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => <OnboardingContainer>{children}</OnboardingContainer>;
